import { Injectable } from '@angular/core';
import { UserPermissionService } from 'shared/services/user-permissions/user-permission.service';
import { WorkItemTypes } from 'common/workitems/constants/workitem-types';
import { ActionPermissionType } from 'common/common/constants/permission-type-enum';
import { ServiceEvaluatorService } from 'shared/services/service-evaluator/service-evaluator.service';
import { bcEnums } from 'common/common/constants/boldchat-enums';

@Injectable()
export class QueueViewPermissionsService {
  constructor(private _userPermissionService: UserPermissionService,
              private _serviceEvaluator: ServiceEvaluatorService) { }

  public hasAssignPermission(workItemType: WorkItemTypes): boolean {
    switch (workItemType) {
      case WorkItemTypes.CHAT:
        return this._userPermissionService.hasPermissionFor(ActionPermissionType.CHAT_ASSIGN_OTHER);
      case WorkItemTypes.EMAIL:
        return this._userPermissionService.hasPermissionFor(ActionPermissionType.EMAIL_ASSIGN_OTHER);
      case WorkItemTypes.SMS:
      case WorkItemTypes.FACEBOOK:
      case WorkItemTypes.ASYNC_MESSAGE:
        return this._userPermissionService.hasPermissionFor(ActionPermissionType.TEXT_CHAT_ASSIGN_OTHER);
      default:
        throw new Error(`Unhandled type (${workItemType})`);
    }
  }

  public hasClosePermission(workItemType: WorkItemTypes): boolean {
    switch (workItemType) {
      case WorkItemTypes.CHAT:
        return this._userPermissionService.hasPermissionFor(ActionPermissionType.CHAT_END_OTHER);
      case WorkItemTypes.EMAIL:
        return this._userPermissionService.hasPermissionFor(ActionPermissionType.EMAIL_CLOSE_OTHER);
      case WorkItemTypes.SMS:
      case WorkItemTypes.FACEBOOK:
      case WorkItemTypes.ASYNC_MESSAGE:
        return this._userPermissionService.hasPermissionFor(ActionPermissionType.TEXT_CHAT_END_OTHER);
      default:
        throw new Error(`Unhandled type (${workItemType})`);
    }
  }

  public hasColumnChooserPermission(workItemType: WorkItemTypes): boolean {
    switch (workItemType) {
      case WorkItemTypes.CHAT:
        return this._userPermissionService.hasPermissionFor(ActionPermissionType.CHAT_GRID_COLUMN_CHOOSER);
      case WorkItemTypes.EMAIL:
        return this._userPermissionService.hasPermissionFor(ActionPermissionType.EMAIL_COLUMN_CHOOSER);
      case WorkItemTypes.SMS:
      case WorkItemTypes.FACEBOOK:
      case WorkItemTypes.ASYNC_MESSAGE:
        return this._userPermissionService.hasPermissionFor(ActionPermissionType.TEXT_CHAT_COLUMN_CHOOSER);
      default:
        throw new Error(`Unhandled type (${workItemType})`);
    }
  }

  public hasGridViewActivePermission(workItemType: WorkItemTypes): boolean {
    switch (workItemType) {
      case WorkItemTypes.CHAT:
        return this._userPermissionService.hasPermissionFor(ActionPermissionType.CHAT_GRID_VIEW_ACTIVE);
      case WorkItemTypes.SMS:
        return this._userPermissionService.hasPermissionFor(ActionPermissionType.TEXT_CHAT_GRID_VIEW_ACTIVE);
      default:
        throw new Error(`Unhandled type (${workItemType})`);
    }
  }

  public hasGridViewInactivePermission(workItemType: WorkItemTypes): boolean {
    switch (workItemType) {
      case WorkItemTypes.CHAT:
        return this._userPermissionService.hasPermissionFor(ActionPermissionType.CHAT_GRID_VIEW_INACTIVE);
      case WorkItemTypes.SMS:
        return this._userPermissionService.hasPermissionFor(ActionPermissionType.TEXT_CHAT_GRID_VIEW_INACTIVE);
      default:
        throw new Error(`Unhandled type (${workItemType})`);
    }
  }

  public isServiceTypeAvailable(workItemType: WorkItemTypes): boolean {
    let serviceType;

    switch (workItemType) {
      case WorkItemTypes.EMAIL:
        serviceType = bcEnums.services.EMAILS;
        break;
      case WorkItemTypes.CHAT:
        serviceType = bcEnums.services.CHATS;
        break;
      case WorkItemTypes.SMS:
        serviceType = bcEnums.services.SMS;
        break;
    }

    return this._serviceEvaluator.isServiceEnabled(serviceType) && this._serviceEvaluator.hasAccessForService(serviceType);
  }
}
